import React from 'react';
import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';
import { formattedEurToPln, getAmountInPLN } from '../utils/currency';
import { calculateGroupedByCurrencyTotalProfit } from '../utils/profit';

type TransportOrdersProfitSummaryProps = {
    transportOrders: Array<TransportOrder>;
    currencyRecord: CurrencyRecord;
}

export const TransportOrdersProfitSummary = ({
    transportOrders,
    currencyRecord,
}: TransportOrdersProfitSummaryProps) => {
    const groupedTotalProfits = calculateGroupedByCurrencyTotalProfit(transportOrders, currencyRecord).sort(([aCurrency, a], [bCurrency, b]) => b - a);
    const totalInPln = groupedTotalProfits.map(([currency, profit]) => getAmountInPLN(currencyRecord, profit, currency as SupportedCurrency))
        .reduce((acc, curr) => acc + curr, 0);

    if (groupedTotalProfits.length === 0) {
        return <span>0</span>;
    }

    return <>
        {groupedTotalProfits.map(([currency, profit], index) => <>
            <span
                key={currency}
                className={profit > 0 ? 'text-success' : 'text-danger'}>{profit.toLocaleString('pl-PL', {
                style: 'currency',
                currency,
            })}</span>{index < groupedTotalProfits.length - 1 ? ', ' : ''}
        </>)} <span>({totalInPln.toLocaleString('pl-PL', {
        style: 'currency',
        currency: 'PLN',
    })} po kursie {formattedEurToPln(currencyRecord)})</span>
    </>;
};